export const SHOW_POPUP = 'SHOW_POPUP';
export const HIDE_POPUP = 'HIDE_POPUP';

export const showPopup = (message, onConfirm) => {
  return {
    type: SHOW_POPUP,
    payload: { message, onConfirm },
  };
};

export const hidePopup = () => {
  return {
    type: HIDE_POPUP,
  };
};